module.exports = __webpack_public_path__ + "assets/img/marketplace.b5641907.png";